import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { useDarkMode } from '../context/DarkModeContext';

const faqs = [
  {
    q: 'What is usefultoolz.com?',
    a: 'usefultoolz.com is a free online collection of tools for working with text and JSON—no signup required. It includes features for comparison, validation, formatting, and utilities like password and UUID generation.'
  },
  {
    q: 'Is my data safe?',
    a: 'Yes! All processing happens in your browser. Your data never leaves your device and is not stored or sent to any server.'
  },
  {
    q: 'Can I use this on mobile?',
    a: 'Absolutely. The site is fully responsive and works great on mobile, tablet, and desktop.'
  },
  {
    q: 'How do I report a bug or request a feature?',
    a: (
      <>
        You can report a bug or request a feature by visiting my {' '}
        <a
          href="https://www.linkedin.com/in/naveen-k-59a99a99/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn profile
        </a>
      </>
    )  },
  {
    q: 'Is usefultoolz.com free to use?',
    a: 'Yes, all features are completely free to use.'
  }
];

export default function FaqPage() {
  const navigate = useNavigate();
  const { darkMode, toggleDarkMode } = useDarkMode();
  const [openIndexes, setOpenIndexes] = useState([]);

  const handleToggle = (idx) => {
    setOpenIndexes((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary', p: 3, display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {/* Dark mode toggle in top right corner */}
      <button
        onClick={toggleDarkMode}
        className="dark-mode-toggle"
        style={{ 
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 1000,
          color: '#fff',
          fontSize: '1rem',
          padding: '8px 16px',
          borderRadius: '4px',
          backgroundColor: '#1976d2',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '40px'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
        onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
      >
        <span className="dark-mode-text">
          {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
        </span>
        <span className="dark-mode-icon">
          {darkMode ? '☀️' : '🌙'}
        </span>
      </button>
      <Box sx={{ mt: { xs: 7, sm: 0 }, mb: 3, alignSelf: 'flex-start' }}>
        <img
          src="/favicon.png"
          alt="Home"
          onClick={() => navigate('/')}
          title="Go to Home"
          style={{ height: '60px', width: '60px', cursor: 'pointer', borderRadius: '8px', flexShrink: 0, transition: 'opacity 0.15s' }}
          onMouseEnter={(e) => e.currentTarget.style.opacity = '0.75'}
          onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
        />
      </Box>
              <Typography variant="h4" sx={{ color: '#1565c0', fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
        Frequently Asked Questions
      </Typography>
      <Box sx={{ maxWidth: 700, mx: 'auto', width: '100%' }}>
        {faqs.map((faq, idx) => {
          const open = openIndexes.includes(idx);
          return (
            <Box key={idx} sx={{ mb: 3, p: 2, borderRadius: 2, bgcolor: 'background.paper', boxShadow: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleToggle(idx)}>
                <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 600, mb: 0, flex: 1 }}>
                  {faq.q}
                </Typography>
                <IconButton size="small" sx={{ color: '#1976d2' }}>
                  {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </Box>
              {open && (
                <Typography variant="body1" sx={{ color: 'text.primary', mt: 1 }}>
                  {faq.a}
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
      <Footer />
    </Box>
  );
} 